<template>
  <w-sliding-popup type="setting" ref="slidingPopup" title="장비 권한 설정" width="1200px" @close="close">
    <div slot="content">
      <el-steps :active="activeStep" finish-status="success">
        <el-step v-for="(step, index) in stepTitles" :key="index" :title="`${index + 1}.${step}`"></el-step>
      </el-steps>
      <div v-show="activeStep === 0">
        <w-device-auth-setting ref="deviceAuthSetting" :show-flag="activeStep === 0" :checked-obj-list="checkedObjList" :fit-height="true"
        style="height: calc(100vh - 540px);"/>
      </div>
      <div v-show="activeStep === 1">
        <w-user-auth-setting ref="userAuthSetting" :active="activeStep === 1" :type="type" :obj-ids="checkedObjIds" :fit-height="true"
        style="height: calc(100vh - 500px);" />
      </div>
    </div>
    <el-row slot="footer" type="flex" justify="space-between">
      <div>
        <el-button size="large" v-show="activeStep === 1" @click="activeStep = activeStep - 1">이전</el-button>
      </div>
      <div>
        <el-button size="large" v-show="activeStep === 0" :disabled="checkedObjList.length === 0" type="solid" @click="setDeviceAuth('ADD')">권한 할당</el-button>
        <el-button size="large" v-show="activeStep === 0" :disabled="checkedObjList.length === 0" type="solid" @click="setDeviceAuth('DELETE')">권한 해제</el-button>
        <el-button size="large" v-show="activeStep === 1" type="solid" @click="saveDeviceAuth">완료</el-button>
        <el-button size="large" @click="closePopup">취소</el-button>
      </div>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import UserSettingAPI from '@/api/settings/user/user-setting';
import WDeviceAuthSetting from '../../components/DeviceAuthSetting';
import WUserAuthSetting from './components/UserAuthSetting';

export default {
  name: 'WDeviceAuthSettingPopup',
  components: {
    WDeviceAuthSetting,
    WUserAuthSetting,
  },
  data() {
    return {
      activeStep: -1,
      stepTitles: ['장비 선택', '계정 선택'],
      type: null,
      checkedObjList: [],
      userList: [],
      checkedObjIds: [],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.activeStep = 0;
    },
    close() {
      this.activeStep = -1;
      this.checkedObjList = [];
      this.$refs.deviceAuthSetting.initData();
      this.$refs.userAuthSetting.initData();
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
    setDeviceAuth(type) {
      const objIds = this.$refs.deviceAuthSetting.getDeviceAuthSettingData().objIds;
      this.checkedObjIds = objIds;
      this.type = type;
      this.activeStep = this.activeStep + 1;
    },
    saveDeviceAuth() {
      const objIds = this.$refs.deviceAuthSetting.getDeviceAuthSettingData().objIds;
      const managerIds = this.$refs.userAuthSetting.getManagerIds();
      const type = this.type;

      const params = {
        objIds,
        managerIds,
        type,
      };
      UserSettingAPI.setMgrObj(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '장비 권한 설정', true));
          this.closePopup();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '장비 권한 설정', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '장비 권한 설정', false));
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/popup/DeviceAuthSettingPopup/index.vue